import { useState } from "react";
import { Form, Input, Select, Button, Checkbox, Radio, Modal } from "antd";
import { useEffect } from "react";
import "./PonudjeniOdgovorStyle.css";
import "./AddNewPitanje.css";

const { TextArea } = Input;

const { Option } = Select;

function AddNewPitanje({ onSubmit, counter }) {
  const [tekstPitanja, setTekstPitanja] = useState("");
  const [objasnjenje, setObjasnjenje] = useState("");
  const [tip, setTip] = useState("TEKSTUALNO");
  const [odgovori, setOdgovori] = useState([]);
  const [novaOpcija, setNovaOpcija] = useState("");
  const [obavezno, setObavezno] = useState(false);
  const [pozicija, setPozicija] = useState(counter + 1);
  const [newAnswerConfirmIndex, setNewAnswerConfirmIndex] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    setPozicija(counter + 1);
  }, [counter]);

  const handleTipChange = (value) => {
    setTip(value);
    if (value === "DA_NE") {
      setOdgovori(["Da", "Ne"]);
    } else {
      setOdgovori([]);
    }
  };

  const handleAddOdgovor = () => {
    if (novaOpcija.trim() !== "" && !odgovori.includes(novaOpcija)) {
      setOdgovori([...odgovori, novaOpcija]);
      setNovaOpcija("");
    }
  };

  const isFormValid = () => {
    return tekstPitanja.trim() !== "" && tip.trim() !== "";
  };
  const handleModalOk = () => {
    setModalVisible(false);
  };
  const checkQuestion = () => {
    if (!isFormValid()) {
      setModalVisible(true);
      return;
    }
    handleSubmit();
  };

  const handleSubmit = () => {
    const novoPitanje = {
      tekstPitanja,
      objasnjenje,
      tip,
      obavezno,
      pozicija,
      ponudjeniOdgovori: odgovori
        ? odgovori.map((odgovor) => ({
            tekstOdgovora: odgovor,
          }))
        : [],
    };

    onSubmit(novoPitanje);
    setTekstPitanja("");
    setObjasnjenje("");
    setTip("TEKSTUALNO");
    setOdgovori([]);
  };

  const handleRemoveOdgovor = (index) => {
    setOdgovori((prev) => prev.filter((_, i) => i !== index));
  };

  const handleMoveUp = (index) => {
    if (index === 0) return;
    setOdgovori((prev) => {
      const newOdgovori = [...prev];
      [newOdgovori[index - 1], newOdgovori[index]] = [
        newOdgovori[index],
        newOdgovori[index - 1],
      ];
      return newOdgovori;
    });
  };

  const handleMoveDown = (index) => {
    if (index === odgovori.length - 1) return;
    setOdgovori((prev) => {
      const newOdgovori = [...prev];
      [newOdgovori[index], newOdgovori[index + 1]] = [
        newOdgovori[index + 1],
        newOdgovori[index],
      ];
      return newOdgovori;
    });
  };
  return (
    <div className="new-pitanje-card">
      <h2 className="title">Novo pitanje</h2>
      <Form
        layout="horizontal"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        className="poll-form"
      >
        <Form.Item label="Tekst pitanja" required>
          <TextArea
            className="textarea-field add-new-pitanje-input"
            value={tekstPitanja}
            onChange={(e) => setTekstPitanja(e.target.value)}
            placeholder="Unesite pitanje"
          />
        </Form.Item>

        <Form.Item label="Objašnjenje">
          <TextArea
            className="textarea-field add-new-pitanje-input"
            value={objasnjenje}
            onChange={(e) => setObjasnjenje(e.target.value)}
            placeholder="Unesite objašnjenje"
          />
        </Form.Item>

        <Form.Item
          label="Obavezno"
          name="obavezno"
          valuePropName="obavezno"
          style={{ paddingLeft: "5px" }}
        >
          <Radio.Group
            onChange={(e) => setObavezno(e.target.value === "Da")}
            defaultValue="Ne"
          >
            <Radio value="Da"> Da </Radio>
            <Radio value="Ne"> Ne </Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item label="Tip pitanja" required>
          <Select
            value={tip}
            onChange={(value) => {
              handleTipChange(value);
            }}
            className="select-field add-new-pitanje-select"
          >
            <Option value="TEKSTUALNO">Tekst</Option>
            <Option value="DA_NE">Da / Ne</Option>
            <Option value="VISESTRUKI_IZBOR">Višestruki izbor</Option>
            <Option value="JEDAN_IZBOR">Jednostruki izbor</Option>
          </Select>
        </Form.Item>

        {tip === "DA_NE" && (
          <Form.Item label="Ponuđeni odgovori">
            <Radio>Da</Radio>
            <Radio>Ne</Radio>
          </Form.Item>
        )}

        {tip === "JEDAN_IZBOR" && (
          <Form.Item labelCol={{ span: 0 }} wrapperCol={{ span: 24 }}>
            <div className="jedan-izbor-wrapper">
              <div className="odgovori-label">Ponuđeni odgovori:</div>
              <Radio.Group
                style={{
                  maxWidth: "95%",
                  width: "95%",
                  margin: "0 auto",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div className="novi-odgovori-container">
                  {odgovori.map((option, index) => (
                    <div key={index} className="odgovor-item">
                      <div className="checkbox-container">
                        <Radio value={option}>{option}</Radio>
                      </div>
                      <div className="button-group">
                        <button
                          onClick={() => handleMoveUp(index)}
                          className="move-btn move-up"
                        >
                          ↑
                        </button>
                        <button
                          onClick={() => handleMoveDown(index)}
                          className="move-btn move-down"
                        >
                          ↓
                        </button>
                        <button
                          className="delete-button"
                          onClick={() =>
                            setNewAnswerConfirmIndex(
                              newAnswerConfirmIndex === index ? null : index
                            )
                          }
                        >
                          ✖
                        </button>

                        {newAnswerConfirmIndex === index && (
                          <div className="confirm-popup">
                            <p className="confirm-text">
                              Obrisati ponuđeni odgovor?
                            </p>
                            <div className="confirm-buttons">
                              <button
                                className="confirm-btn confirm-yes"
                                onClick={() => {
                                  handleRemoveOdgovor(index);
                                  setNewAnswerConfirmIndex(null);
                                }}
                              >
                                Da
                              </button>
                              <button
                                className="confirm-btn confirm-no"
                                onClick={() => setNewAnswerConfirmIndex(null)}
                              >
                                Ne
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </Radio.Group>
              <div className="input-container">
                <Input
                  className="input-field add-new-pitanje-input"
                  value={novaOpcija}
                  onChange={(e) => setNovaOpcija(e.target.value)}
                  placeholder="Unesite novu opciju"
                />
                <Button onClick={handleAddOdgovor} className="button-primary">
                  Dodaj opciju
                </Button>
              </div>
            </div>
          </Form.Item>
        )}

        {tip === "VISESTRUKI_IZBOR" && (
          <Form.Item labelCol={{ span: 0 }} wrapperCol={{ span: 24 }}>
            <div className="jedan-izbor-wrapper">
              <div className="odgovori-label">Ponuđeni odgovori:</div>

              <div className="novi-odgovori-container">
                <Checkbox.Group
                  style={{
                    maxWidth: "95%",
                    width: "95%",
                    margin: "0 auto",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {odgovori.map((option, index) => (
                    <div key={index} className="odgovor-item">
                      <div className="checkbox-container">
                        <Checkbox value={option}>{option}</Checkbox>
                      </div>
                      <div className="add-ponudjeni-odgovor-button-group">
                        <button
                          onClick={() => handleMoveUp(index)}
                          className="move-btn move-up"
                        >
                          ↑
                        </button>
                        <button
                          onClick={() => handleMoveDown(index)}
                          className="move-btn move-down"
                        >
                          ↓
                        </button>
                        <button
                          onClick={() => handleRemoveOdgovor(index)}
                          className="delete-button"
                        >
                          ✖
                        </button>
                      </div>
                    </div>
                  ))}
                </Checkbox.Group>
              </div>
              <div className="input-container">
                <Input
                  className="input-field add-new-pitanje-input"
                  value={novaOpcija}
                  onChange={(e) => setNovaOpcija(e.target.value)}
                  placeholder="Unesite novu opciju"
                />
                <Button onClick={handleAddOdgovor} className="button-primary">
                  Dodaj opciju
                </Button>
              </div>
            </div>
          </Form.Item>
        )}
      </Form>

      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Button
          type="primary"
          size="large"
          onClick={() => checkQuestion()}
          className="button-primary"
        >
          Dodaj pitanje
        </Button>
      </div>
      <Modal
        title="Greška"
        open={modalVisible}
        onCancel={handleModalOk}
        footer={[
          <Button key="back" type="primary" onClick={handleModalOk}>
            Povratak
          </Button>,
        ]}
        className="saglasnost-modal"
      >
        <p>Nisu popunjena sva obavezna polja.</p>
      </Modal>
    </div>
  );
}

export default AddNewPitanje;
